import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.less";
import cx from "classnames";
import { BREAD_CRUMBS_STEPS } from "../../constants/constants";

const BreadCrumbsDots = props => {
  const { activeBreadCrumb, isRtl, titles } = props;
  const breadCrumbKeys = Object.keys(BREAD_CRUMBS_STEPS);
  return (
    <div className={styles.breadCrambsWrapper}>
      <div className={styles.breadCrambStep} />
      {breadCrumbKeys &&
        breadCrumbKeys.map((elem, index) => {
          return (
            <div
              className={cx(styles.breadCrambStep, styles.elem, {
                [styles.active]: BREAD_CRUMBS_STEPS[elem] == activeBreadCrumb,
                [styles.rtl]: isRtl
              })}
              key={elem}
            >
              <div className={styles.breadCrambDot}>{index + 1}</div>
              <div className={styles.bcText}>
                {titles[BREAD_CRUMBS_STEPS[elem]]}
              </div>
            </div>
          );
        })}
    </div>
  );
};

BreadCrumbsDots.propTypes = {
  activeBreadCrumb: PropTypes.string,
  isRtl: PropTypes.bool,
  titles: PropTypes.object
};
export default BreadCrumbsDots;



// WEBPACK FOOTER //
// ./src/components/BreadCrumbsDots/BreadCrumbsDots.js